import requestProvider from "./axiosHandler";

const getAllEmployee = () => {

    return requestProvider
        .get('/employee/get-all')
};

const deleteEmployee = (id) => {

    return requestProvider
        .delete(`/employee/${id}`)
};

const updateEmployee = (list) => {

    return requestProvider
        .put('/employee', {
            name: list.name,
            surname: list.surname,
            code: list.employeeCode,
            username: list.username,
            password: list.password,
            id: list.id,
            department: {
                id: list.department
            },
            birthdate: list.birthdate,
            phoneNumber: list.phoneNumber,
            internalPhoneCode: list.internalPhoneCode,
            title: list.title
        })
};

const createEmployee = (list) => {

    return requestProvider
        .post('/employee', {
            name: list.name,
            surname: list.surname,
            code: list.employeeCode,
            username: list.username,
            password: list.password,
            department: {
                id: list.department
            },
            birthdate: list.birthdate,
            phoneNumber: list.phoneNumber,
            internalPhoneCode: list.internalPhoneCode,
            title: list.title
        })
};

const getEmployeeById = (id) => {
    return requestProvider
        .get(`/employee/${id}`);
};

const getEmployeesAsSelect = () => {
    return requestProvider
        .get('employee/select');
};
const getEmployeesWithPage = (page = 0, pageSize = 10) => {
    return requestProvider
        .get(`/employee?field=createdDate&order=desc&page=${page}&per_page=${pageSize}`)
}; 

export {getAllEmployee, deleteEmployee, updateEmployee, createEmployee, getEmployeeById, getEmployeesAsSelect, getEmployeesWithPage}